import { useTranslation } from '../../../lib/i18n';
import { Card, Typography } from '../ui';
import { FileKindGlyph } from '../FileArtifactCard';
import { taskFileKey, type TaskFile } from '../../../lib/task-files';
import styles from './TaskFilesSection.module.css';

// The task's produced files (Option B, below the plan/live transcript): a "Files" title + a chip per
// file, each opening the in-app doc viewer on click — the web mirror of native's TaskScreen Files
// carousel. Renders NOTHING when the task produced no file — no title, no empty state — matching native.
export function TaskFilesSection({ files, onOpen }: { files: TaskFile[]; onOpen: (file: TaskFile) => void }) {
  const { t } = useTranslation();
  if (files.length === 0) return null;

  return (
    <section className={styles.section} aria-label={t('files.title')}>
      <Typography variant="h4" component="h3">
        {t('files.title')}
      </Typography>
      <div className={styles.list}>
        {files.map((file) => (
          <Card
            key={taskFileKey(file)}
            variant="stone"
            size="sm"
            interactive
            component="button"
            className={styles.chip}
            title={file.name}
            onClick={() => onOpen(file)}
          >
            <FileKindGlyph isApp={false} size={18} />
            <Typography variant="p2" component="span" noWrap className={styles.name}>
              {file.name}
            </Typography>
          </Card>
        ))}
      </div>
    </section>
  );
}
